import {
  HttpRequest,
  HttpInterceptorFn,
  HttpHandlerFn,
  HttpEvent,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { getCookie, today } from '@poste-click-connect/shared-ui';
import { Observable, finalize, tap } from 'rxjs';
import { InterceptorService } from '../services/interceptor.service';
import { ErrorCodes } from '../enums/error-codes.enum';

export const authInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const token = getCookie('accessToken');
  let clonedRequest = request;
  const service = inject(InterceptorService);
  service.start();

  if (token) {
    clonedRequest = request.clone({
      ...(request.method === 'GET'
        ? {
            url: `${request.url}${
              request.url.indexOf('?') >= 0 ? '&' : '?'
            }timestamp=${today()}`,
          }
        : {}),
      setHeaders: {
        Authorization: `${token}`,
      },
    });
  } else {
    clonedRequest = request.clone({
      ...(request.method === 'GET'
        ? {
            url: `${request.url}${
              request.url.indexOf('?') >= 0 ? '&' : '?'
            }timestamp=${today()}`,
          }
        : {})
    });
  }

  return next(clonedRequest).pipe(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    tap((response: any) => {
      if (response?.body?.msgCode === ErrorCodes.AUTHORIZATION_DENIED) {
        service.logout();
      }
    }),
    finalize(() => {
      service.end();
    })
  );
};
